import { ArrowLeftIcon, Link2Icon, XIcon } from 'lucide-react';

import { Button, ButtonGroupSeparator, CopyButton } from '@@/ui/primitives';
import clsx from 'clsx';
import { ViewNavigation } from './view-navigation';
import { LogType } from '../types/visualizer';
import { useViewContext } from '../contexts/view-context';

export const InfoBar = (props: {
  contactId: string;
  initiationTimestamp: string;
  relatedContactId?: string;
  previousContactId?: string;
  allowedLogTypes: LogType[];
  selectedLogType: LogType;
  onLogTypeChange: (logType: LogType) => void;
  onClose: () => void;
}) => {
  const { viewContactId } = useViewContext();
  const formattedTime = Intl.DateTimeFormat(navigator.language, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric'
  }).format(new Date(props.initiationTimestamp));

  const hasPreviousOrRelated = props.previousContactId || props.relatedContactId;

  return (
    <div
      className={clsx(
        'flex items-center justify-between',
        'bg-neutral-50/50 border-b border-neutral-200',
        'px-1 h-10 min-h-10'
      )}
    >
      <div className='flex items-center gap-20 text-sm'>
        {props.contactId && (
          <div className='flex items-center gap-2'>
            <ViewNavigation
              allowedLogTypes={props.allowedLogTypes}
              selectedLogType={props.selectedLogType}
              onLogTypeChange={props.onLogTypeChange}
              disabled={false}
            />
            {hasPreviousOrRelated && <ButtonGroupSeparator />}
            {props.previousContactId && (
              <Button
                variant='ghost'
                size='xs'
                className='text-muted-foreground'
                onClick={() => {
                  viewContactId(props.previousContactId!);
                }}
              >
                <ArrowLeftIcon className='size-3.5 mr-1' />
                Previous
              </Button>
            )}
            {props.relatedContactId && (
              <Button
                variant='ghost'
                size='xs'
                className='text-muted-foreground'
                onClick={() => {
                  viewContactId(props.relatedContactId!);
                }}
              >
                <Link2Icon className='size-3.5 mr-1' />
                Related
              </Button>
            )}
          </div>
        )}
      </div>
      <div className='flex items-center ml-8'>
        <div className='text-sm flex gap-4 mr-2'>
          <span className='flex items-center '>
            <span className='tabular-nums'>{props.contactId}</span>
            <CopyButton content={props.contactId} />
          </span>
          <span className='text-muted-foreground tabular-nums'>{formattedTime}</span>
        </div>
        <Button variant='ghost' size='sm' onClick={props.onClose} aria-label='Close'>
          <XIcon className='size-4' />
        </Button>
      </div>
    </div>
  );
};
